import { useReducer } from "react";
import api from "../api/organizations";
import notify from "devextreme/ui/notify";

const intialState = {
  departments: [],
};

const logSuccess = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "success"
  );

function reducer(state, action) {
  switch (action.type) {
    case "DEPARTMENTS":
      return {
        ...state,
        departments: action.departments,
      };
    default:
      return {
        ...state,
        ...action.payload
      };
  }
}

export default function useOrgStructure() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

    function getDepartments(orgId) {
        api.getOrganizationDepartments(orgId).then(({ data }) => {
            dispatch({
                type: "DEPARTMENTS",
                departments: data,
            });
        })
    }

    function updateDepartments(orgId, data) {
      api.updateDepartments(orgId, data).then(({ data }) => {
        logSuccess("Список подразделений успешно обновлён");
        getDepartments(orgId);
      })
    }

  return {
    dataSources,
    getDepartments,
    updateDepartments
  };
}
